import {makeStyles} from '@mui/styles';
import {Box, BoxProps} from '@mui/system';

const useListItemContentStyles = makeStyles(theme => ({
  content: {
    gap: 1,
    minWidth: 0,
    overflow: 'hidden',
  },
  root: {
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden',
    alignItems: 'center',
  },
  leftAdornment: {
    marginRight: theme.spacing(2),
    alignItems: 'flex-start',
    display: 'flex',
  },
}));

interface ListItemContentProps extends BoxProps {
  leftAdornment?: React.ReactNode;
}

const ListItemContent: React.FC<ListItemContentProps> = ({
  children,
  leftAdornment,
  ...rest
}) => {
  const styles = useListItemContentStyles();
  return (
    <Box className={styles.root}>
      {leftAdornment && (
        <Box className={styles.leftAdornment}>{leftAdornment}</Box>
      )}
      <Box className={styles.content} {...rest}>
        {children}
      </Box>
    </Box>
  );
};

export default ListItemContent;
